import HttpDataApi from './http/HttpDataApi';

function getDataApi() {
  if (process.env.REACT_APP_DATA_API_URL) {
    return new HttpDataApi();
  }
  throw new Error(
    "No data api url specified. Use env property 'REACT_APP_DATA_API_URL' to define it."
  );
}

export default getDataApi();
